import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Observable } from 'rxjs';
import { GetAnimalManureTransportResponse } from 'src/app/fertilizers/models/animal-manure-transport.model';
import { Environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AnimalManureTransportService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private baseUrl = this.env.ARABLE_JOIN_DATA_REBUILD_DONE
    ? `${this.env.APIM_BASE_URL}/join-data-integration-v2-service/vdm/`
    : `${this.env.API_BASE_URL}/service/arable-join-data-integration/secure/vdm/`;

  getAnimalManureTransports(
    kvkNumber: string,
    startDate: string,
    endDate: string,
  ): Observable<GetAnimalManureTransportResponse> {
    return this.http.get<GetAnimalManureTransportResponse>(this.baseUrl + `${kvkNumber}`, {
      params: {
        startDate,
        endDate,
      },
    });
  }
}
